import React, {useState} from 'react'
import {Button, Popconfirm} from "antd";
import {deletePurchase} from "../../../services/servicePurchase";
import {enterLoadingState, exitLoadingState} from "../../../utils/helpers/commonFunctions";
import { navigate
 } from '@reach/router';
const DeletePurchase = ({record}) => {
    const [loadings, setLoadings] = useState([])

    const handleDelete = () => {
        enterLoadingState(setLoadings)
        deletePurchase(record.id)
            .then(() => {
                exitLoadingState(setLoadings)
                navigate(`?ps=${10}&pn=${1}&rn=${Math.floor(Math.random(1) * 1000)}`);
            })
            .catch(() => exitLoadingState(setLoadings))
    }

    return(
        <React.Fragment>
            <Popconfirm
                title={'Silmek istediğinizden emin misiniz ?'}
                okText={'Onayla'}
                cancelText={'VAZGEÇ'}
                okButtonProps={{type: 'danger', loading: loadings[0]}}
                onConfirm={handleDelete}
            >
                <Button
                    type={'link'}
                    danger
                >
                    Sil
                </Button>
            </Popconfirm>
        </React.Fragment>
    )
}
export default DeletePurchase